module.exports = __webpack_public_path__ + "assets/chevin-thin.e68050abdf79e0325cc3c4bf8c4ea1a1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-thin.woff2
// module id = 54
// module chunks = 0